import React from "react"
import {t} from "@lingui/core/macro"
import {Trans} from "@lingui/react/macro"
import {formatMontant} from "./api"

// La carte d'un lot.
//
// Elle doit répondre à trois questions d'un coup d'œil, sur un téléphone, dans
// un couloir : de quoi s'agit-il, où en est-on, est-ce que je mène. Le reste —
// la signification de l'honneur — est ce qui donne envie d'enchérir sur Maftir
// Yona plutôt que sur une ligne anonyme : elle a donc sa place ici, pas dans une
// page à part que personne n'ouvrirait.
export default function LotCard({lot, vente, lang, onEncherir, onAcheter, onOffrir}) {
    const devise = (vente && vente.devise) || "eur"
    const moi = lot.moi || null
    const jeMene = moi && moi.meneur
    const jeSuisDepasse = moi && !moi.meneur && lot.state === "OUVERT" && !lot.aveugle

    const ferme = lot.state !== "OUVERT"
    const resultat = lot.resultat || null

    return (
        <div className={"ench-lot" + (jeMene ? " ench-lot-mene" : "") + (jeSuisDepasse ? " ench-lot-depasse" : "")}>
            <div className="ench-lot-haut">
                <div>
                    <div className="ench-lot-titre">{lot.label}</div>
                    {lot.office && <div className="ench-lot-office">{lot.office}</div>}
                </div>
                {/* Pastille du thème plutôt qu'une étiquette antd : la page doit
                    avoir l'air d'appartenir au site, pas d'y être collée. */}
                {lot.restrictTribu && (
                    <span className="ench-lot-badge">
                        {lot.restrictTribu === "COHEN" ? t`Cohanim` : (lot.restrictTribu === "LEVI" ? t`Léviim` : t`Israël`)}
                    </span>
                )}
            </div>

            {lot.description && <div className="ench-lot-sens">{lot.description}</div>}

            {/* Un lot vendu sur place est là pour être VU : on annonce sa mise de
                départ et on dit clairement que la vente se fait à la synagogue. */}
            {lot.surPlace ? (
                <div className="ench-lot-surplace">
                    <div className="ench-lot-montant">{formatMontant(lot.startPrice, devise, lang)}</div>
                    <div className="ench-lot-mention"><Trans>Vente à la synagogue</Trans></div>
                </div>
            ) : lot.aveugle ? (
                <div className="ench-lot-corps">
                    <div className="ench-lot-mention"><Trans>Offres secrètes : personne ne voit les montants.</Trans></div>
                    {moi && <div className="ench-lot-moi"><Trans>Votre offre : {formatMontant(moi.montant, devise, lang)}</Trans></div>}
                </div>
            ) : (
                <div className="ench-lot-corps">
                    <div className="ench-lot-montant">
                        {lot.currentAmount
                            ? formatMontant(lot.currentAmount, devise, lang)
                            : <span className="ench-lot-vide"><Trans>À partir de {formatMontant(lot.startPrice, devise, lang)}</Trans></span>}
                    </div>
                    {/* Une fois le lot adjugé, la ligne du meneur répéterait le
                        résultat affiché juste en dessous — et « Vous menez » sur
                        une vente close se lit comme si elle continuait. */}
                    {lot.meneur && !resultat && (
                        <div className="ench-lot-meneur">
                            {jeMene ? <Trans>Vous menez</Trans> : lot.meneur.nom}
                        </div>
                    )}
                    {jeSuisDepasse && (
                        <div className="ench-lot-alerte"><Trans>Vous avez été dépassé</Trans></div>
                    )}
                    {moi && moi.plafond && (
                        <div className="ench-lot-plafond"><Trans>Votre maximum : {formatMontant(moi.plafond, devise, lang)}</Trans></div>
                    )}
                </div>
            )}

            {resultat && (
                <div className="ench-lot-resultat">
                    {resultat.estMoi
                        ? <Trans>Vous l'avez emporté à {formatMontant(resultat.montant, devise, lang)}</Trans>
                        : <Trans>Adjugé à {resultat.gagnant} — {formatMontant(resultat.montant, devise, lang)}</Trans>}
                </div>
            )}

            {/* Offrir l'honneur : une coutume courante, et la seule action qui
                reste au gagnant une fois le lot adjugé. Le nom choisi part sur
                la feuille du gabbaï, l'engagement ne bouge pas. */}
            {resultat && resultat.estMoi && (
                <div className="ench-lot-actions">
                    <button type="button" className="ench-btn ench-btn-secondaire" onClick={() => onOffrir && onOffrir(lot)}>
                        {resultat.beneficiaire
                            ? <Trans>Appelé : {resultat.beneficiaire.nomHebreu || resultat.beneficiaire.nom}</Trans>
                            : <Trans>Offrir cet honneur à quelqu'un</Trans>}
                    </button>
                </div>
            )}

            {!ferme && !lot.surPlace && (
                <div className="ench-lot-actions">
                    {lot.kind === "FIXED" ? (
                        <button type="button" className="ench-btn" onClick={() => onAcheter && onAcheter(lot)}>
                            {lot.quantityLeft > 0
                                ? <Trans>Prendre — {formatMontant(lot.fixedPrice, devise, lang)}</Trans>
                                : <Trans>Complet</Trans>}
                        </button>
                    ) : (
                        <>
                            <button type="button" className="ench-btn" onClick={() => onEncherir && onEncherir(lot)}>
                                {jeMene ? <Trans>Augmenter</Trans> : <Trans>Enchérir</Trans>}
                            </button>
                            {lot.buyNowPrice > 0 && (
                                <button type="button" className="ench-btn ench-btn-secondaire" onClick={() => onAcheter && onAcheter(lot)}>
                                    <Trans>Emporter à {formatMontant(lot.buyNowPrice, devise, lang)}</Trans>
                                </button>
                            )}
                        </>
                    )}
                </div>
            )}

            {lot.kind === "FIXED" && lot.quantityLeft !== null && lot.quantityLeft !== undefined && (
                <div className="ench-lot-restant">
                    <Trans>Il reste {lot.quantityLeft} sur {lot.quantity}</Trans>
                </div>
            )}
        </div>
    )
}
